// let api = 'http://121.199.16.88/qgmg/qGMG_backend/index.php';
let api = 'http://mp.fygmg.cn/backend/index.php';
// let api = 'http://8.141.165.155/backend2/index.php';


export default {
  auth_url: `${api}/wechat/auth_url`,  // 获取授权登录url
  getUserinfo: `${api}/wechat/getUserinfo`,  // 获取用户信息
  getInformationInfoByPage: `${api}/wx/Information/getInformationInfoByPage`,  // 资讯列表
  getInformationDetail: `${api}/wx/Information/getInformationDetail`,  // 资讯详情
  getSlider: `${api}/wx/Information/getSlider`,  // 资讯轮播
  getLove: `${api}/wx/love/getLove`,  // 爱心服务
  get_contact: `${api}/wx/about/contact`,  // 认识两馆
  getList: `${api}/wx/show/getList`,  // 云商两馆
  getDetail: `${api}/wx/show/getDetail`,  // 云商两馆详情
  getSignPackage: `${api}/wechat/getSignPackage`,  // 微信分享
  showCates: `${api}/common/showCates2`,  // 获取下拉分类列表
  mediaIncre: `${api}/wx/show/mediaView`,  // 记录音频播放次数
  share_s: `${api}/wx/Information/share`,  // 统计分享次数
  getRecruit: `${api}/wx/recruit/getRecruit`,  // 志愿服务

}



// WEBPACK FOOTER //
// ./src/api/config.js